import "vant/es/slider/style";
import _Slider from "vant/es/slider";
import "core-js/modules/es.array.push.js";
import Vue from 'vue';
import Router from 'vue-router';
import { constantRouterMap } from './router.config.js';
// hack router push callback
var originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(function (err) {
    return err;
  });
};
Vue.use(Router).use(_Slider);
var createRouter = function createRouter() {
  return new Router({
    // mode: 'history', // 如果你是 history模式 需要配置vue.config.js publicPath
    // base: process.env.BASE_URL,
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRouterMap
  });
};
var router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;